import request from '@/utils/request';
import type { R } from '@/api';

/** 阿里云行为验证码 */
export async function showLzdAliyunCaptcha(
  btnId: string,
  elementId: string,
  getInstance: Function,
  captchaVerifyCallback: Function,
  onBizResultCallback: Function
) {
  const userLanguage = () => {
    const i18n_lang = localStorage.getItem('i18n-lang') || 'zh_CN';
    if ('zh_TW' === i18n_lang) {
      return 'tw';
    }
    if ('en' === i18n_lang) {
      return 'en';
    }
    return 'cn';
  };
  globalThis.initAliyunCaptcha({
    SceneId: '111vvtbx', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
    prefix: '46kvth', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
    mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
    element: elementId, //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
    button: btnId, // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
    captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
    onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
    getInstance: getInstance, // 绑定验证码实例函数，无需修改
    slideStyle: {
      width: 360,
      height: 40
    }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
    language: userLanguage(), // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    region: 'cn' //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
  });
}

export async function sendSmsCaptcha(
  ticket: string,
  tenantId: string,
  phone: string
) {
  const formData = new FormData();

  formData.append('ticket', ticket);
  formData.append('tenantId', tenantId);
  formData.append('phone', phone);
  const res = await request.post<R<string>>(
    '/bsl/system/push/sms/code',
    formData
  );
  return res.data;
}

export async function sendEmailCaptcha(
  ticket: string,
  tenantId: string,
  email: string
) {
  const formData = new FormData();
  formData.append('ticket', ticket);
  formData.append('tenantId', tenantId);
  formData.append('email', email);
  const res = await request.post<R<string>>(
    '/bsl/system/push/email/code',
    formData
  );
  return res.data;
}
